module.exports = __webpack_public_path__ + "img/places-1.209710c8.jpg";